var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.visible)?_c('div',{staticClass:"message-wrap",class:_vm.type},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }